(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsSearch', StatsSearch);

    StatsSearch.$inject = ['$resource'];

    function StatsSearch($resource) {
        var resourceUrl = 'api/stats-search';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
